import { render, staticRenderFns } from "./bidListComponent.vue?vue&type=template&id=f1a3b772&"
import script from "./bidListComponent.vue?vue&type=script&lang=ts&"
export * from "./bidListComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports